export function buildMistakeReviewRequest({
  questionCount
}) {
  return {
    mode: 'TRAINING_MODE',
    limit: questionCount,
    excludeAnswered: 'false',
    incorrectOnly: 'true'
  }
}
